import { PackageProducts } from '@/constants/constants';
import type { Subscription } from '@/types/models.types';

/**
 * Finds and returns the first active package subscription from an array of subscriptions.
 *
 * @param subscriptions - Array of user's subscriptions.
 * @returns The active package subscription or undefined if none exists.
 */
export function findActivePackageSubscription(subscriptions: Subscription[]): Subscription | undefined {
  return subscriptions.find((subscription) => {
    return (
      subscription.active &&
      subscription.product &&
      // @ts-expect-error - product.id is a string, but PackageProducts consists of particular strings
      PackageProducts.includes(subscription.product.id)
    );
  });
}
